import { render } from "./TheAccount.vue?vue&type=template&id=035f31f8&scoped=true"
import script from "./TheAccount.vue?vue&type=script&lang=js"
export * from "./TheAccount.vue?vue&type=script&lang=js"

import "./TheAccount.vue?vue&type=style&index=0&id=035f31f8&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-035f31f8"

export default script